import { useCallback, useEffect, useMemo, useRef } from 'react'

type PostFn = (message: unknown) => void

interface UseBroadcastProps {
  channel?: string
  handleMessage?: (event: MessageEvent) => void
  handleError?: (event: MessageEvent) => void
}

type UseBroadcastResult = [ BroadcastChannel | undefined, PostFn ]

export function useBroadcast ({ channel = 'broadcast', handleMessage, handleError }: UseBroadcastProps): UseBroadcastResult {
  let broadcastRef = useRef<BroadcastChannel>()

  useEffect(() => {
    let broadcast = new BroadcastChannel(channel)
    broadcastRef.current = broadcast

    broadcast.onmessage = handleMessage ?? null
    broadcast.onmessageerror = handleError ?? null

    return () => {
      try {
        broadcast.close()
      } catch (err) {}
    }
  }, [
    channel,
    handleMessage,
    handleError
  ])

  let post = useCallback<PostFn>((message: unknown) => {
    broadcastRef.current?.postMessage(message)
  }, [])

  let result = useMemo<UseBroadcastResult>(() => [
    broadcastRef.current,
    post
  ], [
    broadcastRef,
    post
  ])

  return result
}
